/** biome-ignore-all lint/correctness/useHookAtTopLevel: <hoc라 어쩔 수 없음. 추후에 컴포넌트를 분리해야 함.> */
'use client';

import { useTokenStore } from 'Shared/hooks/useTokenStore';
import { sendGTMEvent } from '@next/third-parties/google';
import jwtDecode from 'jwt-decode';
import { usePathname } from 'next/navigation';
import type { ComponentType } from 'react';
import { useEffect, useRef } from 'react';

export const WithGtmDataLayer = <P extends object>(Component: ComponentType<P>) => {
  return function Hoc(props: P & { pageName: string }) {
    const pathname = usePathname();
    const pageStartTime = useRef<number>(0);
    const { accessToken } = useTokenStore();

    useEffect(() => {
      if (!accessToken) return;

      try {
        const userUuid = jwtDecode<{ userUuid: string }>(accessToken)?.userUuid;

        if (!userUuid) return;

        const dataLayer = window.dataLayer || [];
        dataLayer.push({
          user_id: userUuid,
        });

        window.dataLayer = dataLayer;
      } catch (_e) {
        // console.log('token decode error');
      }
    }, []);

    useEffect(() => {
      pageStartTime.current = Date.now();

      return () => {
        sendGTMEvent({
          event: 'ga-leave',
          'gtm.elementClasses': `ga-leave-${props.pageName}`,
          stay_time: (Date.now() - pageStartTime.current) / 1000,
        });
      };
    }, [pathname]);

    return <Component {...props} />;
  };
};
